var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossaryStep = function SvgGlossaryStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.943 1.623c.188-.187.442-.293.708-.293h8.335V10H2.651c-.35 0-.692.079-1.002.226V2.332c0-.266.106-.52.294-.709ZM12.316.665v13.333a.665.665 0 0 1-.665.665h-9a2.332 2.332 0 0 1-2.332-2.332v-10A2.332 2.332 0 0 1 2.651 0h9c.367 0 .665.298.665.665ZM2.651 11.33h8.335v2.003H2.651a1.002 1.002 0 0 1-.708-1.71c.188-.188.442-.293.708-.293Zm4.244-8.328a.665.665 0 0 0-1.155 0l-1.822 3.19a.664.664 0 0 0-.179.312l-.665 1.164a.665.665 0 1 0 1.154.66l.57-.998h3.039l.57.998a.665.665 0 0 0 1.155-.66L6.895 3.002ZM7.077 6H5.559l.759-1.328L7.077 6Z",
    clipRule: "evenodd"
  })));
};
export default SvgGlossaryStep;